import { useState } from "react";
import Tour from "reactour";

export default function Walkthrough(props) {
    const [openWalkthrough, setOpenWalkthrough] = useState(props.tourOpen)

    function closeWalkthroughHandler() {
        props.onCloseFunction && props.onCloseFunction.forEach(item => item());
        setOpenWalkthrough(false);
    }

    return (
        <Tour
            steps={props.steps}
            isOpen={openWalkthrough}
            onRequestClose={() => closeWalkthroughHandler()}
            showNumber={false}
            rounded={8}
            showNavigation={false}
            showButtons={false}
            className="mask"
            accentColor="#26CBA7"
            showCloseButton={false}
        />
    )

}